<div class="guias-rejeitadas-filtro relative">
  <p-button
    icon="pi pi-filter"
    [styleClass]="'p-button-primary p-button-outlined ' + (count ? 'filter-active' : '')"
    [label]="label"
    (click)="onShow($event)"
  ></p-button>
  @if (count > 0) {
    <i
      class="pi pi-times-circle filter-clear-icon cursor-pointer icon-clear w-1rem h-1rem"
      pTooltip="Limpar todos os filtros"
      tooltipPosition="bottom"
      (click)="onClear()"
    ></i>
  }

  <p-popover #filterPanel styleClass="filtro-guias-rejeitadas-popover">
    <ng-template pTemplate="content">
      <div class="filter-panel">
        <div class="filter-columns-container">
          <div class="filter-column">
            <div class="field filter-item mb-2">
              <label>Rejeição da guia</label>
              <p-multiSelect
                size="small"
                [options]="motivoGuiaOptions"
                [(ngModel)]="localMotivoGuia"
                placeholder="Todos"
                [filter]="true"
                styleClass="w-full"
                panelStyleClass="filtro-guias-rejeitadas-opcoes"
                [maxSelectedLabels]="1"
                selectedItemsLabel="{0} selecionados"
                [virtualScroll]="true"
                [virtualScrollItemSize]="43"
              ></p-multiSelect>
            </div>

            <div class="field filter-item mb-2">
              <label>Rejeição do item</label>
              <p-multiSelect
                size="small"
                [options]="motivoItemOptions"
                [(ngModel)]="localMotivoItem"
                placeholder="Todos"
                [filter]="true"
                styleClass="w-full"
                panelStyleClass="filtro-guias-rejeitadas-opcoes"
                [maxSelectedLabels]="1"
                selectedItemsLabel="{0} selecionados"
                [virtualScroll]="true"
                [virtualScrollItemSize]="43"
              ></p-multiSelect>
            </div>
          </div>
        </div>

        <hr class="mt-2 mb-3" />

        <div class="w-full flex justify-content-end">
          <p-button styleClass="mr-2 p-button-sm" (click)="onApply()">Aplicar</p-button>
          <p-button styleClass="p-button-sm p-button-outlined" (click)="onClear()">Limpar</p-button>
        </div>
      </div>
    </ng-template>
  </p-popover>
</div>
